import { render } from "./SelectedProducts.vue?vue&type=template&id=35e586d0&scoped=true&ts=true"
import script from "./SelectedProducts.vue?vue&type=script&lang=ts"
export * from "./SelectedProducts.vue?vue&type=script&lang=ts"

import "./SelectedProducts.vue?vue&type=style&index=0&id=35e586d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e586d0"]])

export default __exports__